import React, { useEffect, useState } from "react";
import styles from "./Rotate.module.scss";
import { IMAGES } from "../../constants/images";
import localforage from "localforage";
import { STORAGE_KEYS } from "../../constants/storage";

const Rotate = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  const [cachedImage, setCachedImage] = useState(null);

  const checkOrientation = () => {
    setIsLandscape(window.innerWidth > window.innerHeight);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    const loadCachedImage = async () => {
      const cachedImageBlob = await localforage.getItem(
        `${STORAGE_KEYS.IMAGES}_${IMAGES.ROTATE_IMAGE}`
      );
      if (cachedImageBlob) {
        setCachedImage(URL.createObjectURL(cachedImageBlob));
      }
    };

    loadCachedImage();

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
      if (cachedImage) {
        URL.revokeObjectURL(cachedImage);
      }
    };
  }, []);

  if (!isLandscape) return null;

  return (
    <div className={styles.background}>
      <div className={styles.overlay}>
        <img
          src={cachedImage || IMAGES.ROTATE_IMAGE}
          alt="Rotate your screen"
          className={styles.icon}
        />
      </div>
    </div>
  );
};

export default Rotate;
